import { apiFetch } from '$lib/api/helpers';
import type { InputActionRequest, InputActionResponse } from '$lib/types/input_action';

const PATH = '/input_actions/';

export async function fetchInputActions(keyId?: number) {
  const endpoint = keyId ? `${PATH}?key=${keyId}` : PATH;
  return apiFetch<Array<InputActionResponse>>(endpoint);
}

export async function createInputAction(request: InputActionRequest) {
  return apiFetch<InputActionResponse>(PATH, {
    method: 'POST',
    body: JSON.stringify(request)
  });
}

export async function deleteInputAction(id: number) {
  return apiFetch<void>(`${PATH}${id}/`, { method: 'DELETE' });
}

export async function updateInputAction(id: number, data: Partial<InputActionRequest>) {
  return apiFetch<InputActionResponse>(`${PATH}${id}/`, {
    method: 'PATCH',
    body: JSON.stringify(data)
  });
}
